export const DELETE: string = "DELETE";
export const GET: string = "GET";
export const PATCH: string = "PATCH";
export const POST: string = "POST";
export const PUT: string = "PUT";